export default __webpack_public_path__ + "static/media/tag-left.159431d6.svg";